// extracted by mini-css-extract-plugin
export default {"tabUl":"Tab_tabUl__MRjwB","activeTab":"Tab_activeTab__TNPNx","tabRoot":"Tab_tabRoot__PXNqK","tabButton":"Tab_tabButton__QQBt-"};